'use client';
import React from 'react';
import dynamic from 'next/dynamic';

const HeroCandlestickChartInner = dynamic(
  () => import('./HeroCandlestickChartInner'),
  { ssr: false, loading: () => <div className="w-full h-full bg-transparent" /> }
);

export default function HeroCandlestickChart() {
  return <HeroCandlestickChartInner />;
}